import React, { useContext } from 'react'
import { AppContext } from '../global/index'
import moment from 'moment'
import momentTimezone from 'moment-timezone'

type Props = {
  date: Date | undefined
  showTime?: boolean
}

function Date(props: Props) {
  const { date, showTime } = props
  const { state } = useContext(AppContext)
  const user = state.auth.user

  if (date) {
    if (user) {
      const dateFormat = user.dateFormat
      const timeFormat = user.timeFormat
      const timezone = user.timezone
      const timezoneMomentDate = momentTimezone(date).tz(timezone).toDate()

      if (showTime) {
        return (
          <span>{moment(timezoneMomentDate).format(`${dateFormat} ${timeFormat}`)}</span>
        )
      } else {
        return (
          <span>{moment(timezoneMomentDate).format(`${dateFormat}`)}</span>
        )
      }
    } else {
      return (
        // just a fallback, shouldn't get here
        <span>{date.toLocaleDateString()}</span>
      )
    }
  } else {
    return <span />
  }
}

export default Date

